import type { Except } from '@festina-life/core'
import cx from 'classnames'
import { useState } from 'react'

import { paperStyles } from '../../libs'
import { typographyStyles } from '../../structure'
import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { disabledInputStyles } from '../textInput/rawTextInputStyles'
import { createInternalWrapperPropsAndId } from '../utility'
import {
  RawLazyTextInput,
  type RawLazyTextInputProps,
} from './RawLazyTextInput'

export type LazyTextInputProps = Except<
  RawLazyTextInputProps,
  'onChangeDisplay' | 'onIsLoading'
> &
  InputProps

export const LazyTextInput = ({
  wrapperProps,
  className,
  ...fieldProps
}: LazyTextInputProps) => {
  const [display, setDisplay] = useState<string>()

  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <div
      /* To position badge below input regards of what is going on in inputwrapper */
      >
        <RawLazyTextInput
          {...fieldProps}
          optionsAddOnProps={
            fieldProps.optionsAddOnProps && {
              ...fieldProps.optionsAddOnProps,
              className: cx(
                fieldProps.optionsAddOnProps.className,
                display && 'rounded-bl-none',
              ),
            }
          }
          className={cx(className, display && 'rounded-b-none')}
          onChangeDisplay={setDisplay}
          id={id}
        />
        {display && (
          <div
            className={cx(
              typographyStyles({
                size: 'sm',
                intensity: fieldProps.disabled ? 'tertiary' : 'primary',
              }),
              fieldProps.disabled
                ? disabledInputStyles({ isInError: !!fieldProps.isInError })
                : cx(
                    paperStyles({
                      isFaded: true,
                      ringColor: fieldProps.isInError ? 'error' : 'grey',
                    }),
                    fieldProps.isInError && 'text-error-500! bg-current/10!',
                  ),
              'py-0.5 px-1.5 -mt-px',
              'rounded-b-md',
            )}
          >
            {display}
          </div>
        )}
      </div>
    </InputWrapper>
  )
}
